import type { RouteObject } from "react-router";
import SeriesDashboardPage from "@/src/series/pages/series-dashboard-page";
import SeriesListPage from "@/src/series/pages/series-list-page";

export const seriesRoutes: RouteObject[] = [
	{ index: true, element: <SeriesListPage /> },
	{ path: "/series/:id", element: <SeriesDashboardPage /> },
];
